import React from "react";
import {
  FaAngleRight,
  FaAngleLeft,
  FaChartBar,
  FaThLarge,
  FaShoppingCart,
  FaCog,
  FaSignOutAlt,
  FaBars,
} from "react-icons/fa";
import { NavLink } from "react-router-dom";
import "../styles/navbar.css";
import {
  removeAllCookies,
  isCookieExpired,
  getCookiePathFromURL,
} from "../helpers";
import { useState, useEffect } from "react";
import * as urls from "../urls"; ///utils/urls
import { useCookies } from "react-cookie";
import { getCookie } from "../utils/common";

//Image
import CreditScoreIcon from "../pages/Navbar/image/CreditScoreIcons.png";

const ICON_SIZE = 20;

function NavbarRes({ visible, show }) {
  let domain = window.location.host.split(".")[0];
  if (window.location.host.includes("localhost")) {
    domain = "yoindi";
  }
  console.log("domain name", domain);

  const CookiePath = "/customers";
  console.log({ CookiePath });

  const [orgLogoData, setOrgLogoData] = useState(null);
  console.log("orgLogoData", orgLogoData);

  const [cookies, setCookie] = useCookies(["user"]);
  console.log("Cookies in CreditScore : ", cookies);

  const activeSlide = getCookie("lastSlide");
  console.log("activeSlide : ", activeSlide);

  const handleLogOut = () => {
    removeAllCookies(CookiePath);
    window.location.replace("/customers");
    // setAnchorEl(null);
  };

  return (
    <nav className={!visible?"":"navbar"}>
      <div className="links nav-top">
        <NavLink to="/customers/home/dashboard" className="nav-link">
          {/* <FaThLarge size={ICON_SIZE} /> */}
          <img
            src={CreditScoreIcon}
            style={{ height: "20px", width: "20px" }}
            alt=""
          />
          <span>Credit Score</span>
        </NavLink>
        {/* <NavLink to="/analytics" className="nav-link">
            <FaChartBar size={ICON_SIZE} />
            <span>Analytics </span>
          </NavLink>
          <NavLink to="/orders" className="nav-link">
            <FaShoppingCart size={ICON_SIZE} />
            <span>Orders</span>
          </NavLink>
          <NavLink to="/settings" className="nav-link">
            <FaCog size={ICON_SIZE} />
            <span>Settings</span>
          </NavLink> */}
        <NavLink onClick={handleLogOut} className="nav-link">
          <FaSignOutAlt size={ICON_SIZE} />
          <span>Logout</span>
        </NavLink>
      </div>
    </nav>
  );
}

export default NavbarRes;
